import React from "react";
import colors from "../../common/colors";
import AnchorLink from "../../components/AnchorLink";
import Checkbox from "../../components/Checkbox";
import FormInvalidError from "../../components/FormInvalidError";
import {
    CellBlockField,
    CellBlockProperty,
    CellBlockSection,
    CellBlockTitle,
    CellBlockValue,
} from "../../components/Grid/CellBlock";
import { administratorRoleLabel } from "./administratorListingUtils";
import { AdministratorInfoData } from "./AdministratorInfoForm";

interface AdministratorInfoListingProps {
    data: AdministratorInfoData;
    isValid: boolean;
    showCustomerCreationAllowed?: boolean;
}

const AdministratorInfoListing = (props: AdministratorInfoListingProps) => {
    const {
        firstName,
        lastName,
        phone,
        email,
        customerCreationAllowed,
        municipalityRole,
    } = props.data;

    return (
        <>
            <CellBlockSection>
                <CellBlockTitle>{`${firstName} ${lastName}`}</CellBlockTitle>
            </CellBlockSection>
            <CellBlockSection>
                <CellBlockProperty>Roll</CellBlockProperty>
                <CellBlockValue>
                    {administratorRoleLabel(municipalityRole)}
                </CellBlockValue>
            </CellBlockSection>
            <CellBlockSection>
                <CellBlockProperty>Telefon</CellBlockProperty>
                <CellBlockValue>{phone}</CellBlockValue>
            </CellBlockSection>
            <CellBlockSection>
                <CellBlockProperty>E-postadress</CellBlockProperty>
                <CellBlockField>
                    <AnchorLink>{email}</AnchorLink>
                </CellBlockField>
            </CellBlockSection>
            {props.showCustomerCreationAllowed && customerCreationAllowed && (
                <CellBlockSection>
                    <Checkbox
                        value={true}
                        text="Får lägga till nya slutkunder"
                        iconColor={colors.grayDark}
                        readOnly
                    />
                </CellBlockSection>
            )}
            {!props.isValid && (
                <CellBlockSection>
                    <FormInvalidError />
                </CellBlockSection>
            )}
        </>
    );
};

export default AdministratorInfoListing;
